import { saveLogsApiCall } from "../../containers/add-to-ici/redux/apiCalls";
import { TEXT } from "../constants/texts";

const MAX_RETRIES = 3;

export const logError = async ({ dispatch, err, callerInfo }) => {
  const logApiRequestData = formatEvent(err, callerInfo);
  await dispatch(saveLogs({ requestData: logApiRequestData }));
};

export const logInformation = async ({ dispatch, info, callerInfo }) => {
  const logApiRequestData = formatEvent(info, callerInfo, "Information");
  await dispatch(saveLogs({ requestData: logApiRequestData }));
};

export const logWarning = async ({ dispatch, warning, callerInfo }) => {
  const logApiRequestData = formatEvent(warning, callerInfo, "Warning");
  await dispatch(saveLogs({ requestData: logApiRequestData }));
};

const formatEvent = (err, callerInfo, eventType: string = "Error") => {
  const { callerApi = "", callerFunction = "" } = callerInfo;
  let errMsg = "";
  const errType = eventType === "Error" ? TEXT.ERROR : eventType === "Information" ? TEXT.INFORMATION : TEXT.WARNING;
  const calledFromFunction = callerFunction ? ` | ${TEXT.CALLED_FROM_FUNCTION}: ${callerFunction}` : "";
  const calledFromApi = callerApi ? ` | ${TEXT.CALLED_FROM_API}: ${callerApi}` : "";
  const logPrefix = TEXT.PREFIX_FOR_LOGS + calledFromFunction + calledFromApi;
  switch (true) {
    case typeof err === TEXT.STRING:
      errMsg = `${logPrefix} | ${TEXT.ERROR_STACK}: ${err}`;
      break;
    case err instanceof Error:
      const { name = TEXT.NAME_LOGS, message = TEXT.MESSAGE, stack = {} } = err;
      errMsg = `${logPrefix} | ${name}: ${message} | ${TEXT.ERROR_STACK}: ${stack}`;
      break;
    default:
      errMsg = `${logPrefix} | ${TEXT.UNKNOWN_ERROR}`;
  }
  return {
    Message: errMsg,
    Type: errType,
  };
};

export const saveLogs =
  ({ requestData }, retriesLeft = MAX_RETRIES) =>
  async (dispatch) => {
    const saveLogsResponse = await saveLogsApiCall({ dispatch, requestData });
    const { error } = saveLogsResponse;
    if (error) {
      const retries = retriesLeft - 1;
      if (retriesLeft > 0) {
        dispatch(saveLogs({ requestData }, retries));
      } else {
        console.log("Failed to save logs after maximum retries:", error);
      }
    }
  };
